import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import pick from 'lodash.pick';
import { queryAreaTreeList, queryAreaTodayEvent } from '@/api/api';
import { deleteAction, httpAction } from '@/api/manage';
import MapGetGrid from '@/components/Map/MapGetGrid';
export default {
  name: 'RiverList',
  mixins: [JeecgListMixin],
  components: {
    MapGetGrid: MapGetGrid
  },
  data: function data() {
    return {
      seen: true,
      iExpandedKeys: [],
      loading: false,
      autoExpandParent: true,
      currFlowId: '',
      currFlowName: '',
      disable: true,
      treeData: [],
      visible: false,
      riverTree: [],
      rightClickSelectedKey: '',
      hiding: true,
      model: {},
      dropTrigger: '',
      river: {},
      searchValue: '',
      disableSubmit: false,
      checkedKeys: [],
      selectedKeys: [],
      autoIncr: 1,
      currSelected: {},
      nodeSelected: {},
      formTitle: '添加一级区域',
      form: this.$form.createForm(this),
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      graphDatasource: {
        nodes: [],
        edges: []
      },
      mapAreaList: '',
      validatorRules: {
        title: {
          rules: [{
            required: true,
            message: '请输入区域名称!'
          }]
        },
        alias: {
          rules: [{
            required: true,
            message: '请输入区域编码!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请选择区域状态!'
          }]
        }
      },
      url: {
        add: '/sys/area/add',
        deleteBatch: '/sys/area/deleteBatch',
        exportXlsUrl: '/sys/area/exportXls',
        importExcelUrl: '/sys/area/importExcel'
      }
    };
  },
  computed: {
    importExcelUrl: function importExcelUrl() {
      return "".concat(window._CONFIG['domianURL'], "/").concat(this.url.importExcelUrl);
    }
  },
  methods: {
    coordinateOk: function coordinateOk(value) {
      if (value != null) {
        var a = '';
        value.features.forEach(function (element, index) {
          var b = '';
          element.forEach(function (item, i) {
            b += i == element.length - 1 ? item.join(',') : item.join(',') + '-';
          });
          a += index == value.features.length - 1 ? b : b + ':';
        });
        console.log('coordinateOk', a);
        var data = {
          features: a,
          geoJson: value.geoJson ? value.geoJson : ''
        };
        this.form.setFieldsValue({
          mapStructure: value ? JSON.stringify(data) : null
        });
        this.mapAreaList = data;
      }
    },
    onChange: function onChange(e) {
      this.searchValue = e.target.value;
    },
    loadData: function loadData() {
      this.refresh();
    },
    loadTree: function loadTree() {
      var that = this;
      that.treeData = [];
      that.riverTree = [];
      queryAreaTreeList().then(function (res) {
        console.log('loadTree', res);

        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i]; // console.log('temp', temp)

            that.treeData.push(temp);
            that.riverTree.push(temp); // that.setThisExpandedKeys(temp)
          }

          console.log('that.treeData', that.treeData);
          that.iExpandedKeys = [res.result[0].key];
          that.selectedKeys = [res.result[0].key];
          that.setValuesToForm(res.result[0].data);
          that.currSelected = Object.assign({}, res.result[0].data);
          that.mapAreaList = res.result[0].data.mapStructure ? JSON.parse(res.result[0].data.mapStructure) : null;
          that.loading = false;
        }
      });
    },
    setThisExpandedKeys: function setThisExpandedKeys(node) {
      if (node.children && node.children.length > 0) {
        this.iExpandedKeys.push(node.key);

        for (var a = 0; a < node.children.length; a++) {
          this.setThisExpandedKeys(node.children[a]);
        }
      }
    },
    refresh: function refresh() {
      this.loading = true;
      this.loadTree();
    },
    // 右键操作方法
    rightHandle: function rightHandle(node) {
      this.dropTrigger = 'contextmenu';
      console.log(node.node.eventKey);
      this.rightClickSelectedKey = node.node.eventKey;
    },
    onExpand: function onExpand(expandedKeys) {
      console.log('onExpand', expandedKeys); // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.

      this.iExpandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    backFlowList: function backFlowList() {
      this.$router.back(-1);
    },
    // 右键点击下拉框改变事件
    dropStatus: function dropStatus(visible) {
      if (visible == false) {
        this.dropTrigger = '';
      }
    },
    // 右键下拉关闭下拉框
    closeDrop: function closeDrop() {
      this.dropTrigger = '';
    },
    addRootNode: function addRootNode() {
      this.$refs.nodeModal.add(this.currFlowId, '');
    },
    batchDel: function batchDel() {
      console.log(this.checkedKeys);

      if (this.checkedKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
      } else {
        var ids = '';

        for (var a = 0; a < this.checkedKeys.length; a++) {
          ids += this.checkedKeys[a] + ',';
        }

        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '确定要删除所选中的 ' + this.checkedKeys.length + ' 条数据（包括下级区域）?',
          onOk: function onOk() {
            deleteAction(that.url.deleteBatch, {
              ids: ids
            }).then(function (res) {
              if (res.success) {
                that.$notification.success({
                  message: res.message
                });
                that.loadTree();
                that.onClearSelected();
              } else {
                that.$notification.warning({
                  message: res.message
                });
              }
            });
          }
        });
      }
    },
    regionChange: function regionChange(type, value) {
      var _this = this;

      if (this.selectedKeys.length > 0) {
        queryAreaTodayEvent({
          areaId: this.selectedKeys[0],
          features: this.mapAreaList ? this.mapAreaList.features : null
        }).then(function (res) {
          var center = window.localStorage.getItem('mapCenter') && window.localStorage.getItem('mapCenter') != 'null' ? window.localStorage.getItem('mapCenter').split(',') : [118.047928, 24.613341];

          if (res.mapCenter) {
            center = JSON.parse(res.mapCenter);
          }

          if (_this.form.getFieldValue('mapStructure') || type != 0) {
            _this.$refs.mapForm.show(type, center, _this.mapAreaList, res.siteCoordinate, value);
          }
        });
      } else {
        this.$message_custom('请选择区域！', 'warn');
      }
    },
    nodeModalOk: function nodeModalOk() {
      this.loadTree();
    },
    nodeModalClose: function nodeModalClose() {},
    hide: function hide() {
      this.visible = false;
    },
    onCheck: function onCheck(checkedKeys, info) {
      console.log('checkedKeys', checkedKeys);
      this.hiding = false;
      this.checkedKeys = checkedKeys.checked;
    },
    onSelect: function onSelect(selectedKeys, e) {
      this.hiding = false;
      var record = e.node.dataRef;
      var recordToForm = e.node.dataRef.data;
      console.log('eeee', recordToForm);
      this.nodeSelected = Object.assign({}, record);
      this.currSelected = Object.assign({}, recordToForm);
      this.model = this.currSelected;
      this.selectedKeys = [record.key];
      this.model.parentId = recordToForm.parentId;
      var tid = window.localStorage.getItem('tenant');

      if (tid != 0 && recordToForm.tenantId == 0) {
        this.disableSubmit = true;
      } else if (tid == 0 || recordToForm.tenantId != 0) {
        this.disableSubmit = false;
      }

      this.setValuesToForm(recordToForm);
      this.mapAreaList = recordToForm.mapStructure ? JSON.parse(recordToForm.mapStructure) : null;
    },
    // 触发onSelect事件时,为部门树右侧的form表单赋值
    setValuesToForm: function setValuesToForm(record) {
      this.seen = record.parentId === '0';
      this.formTitle = '修改区域';
      this.form.setFieldsValue(pick(record, 'title', 'alias', 'phone', 'zip', 'ename', 'spell', 'grade', 'hot', 'mapCode', 'mapStructure', 'status', 'sort', 'remark'));
    },
    getCurrSelectedTitle: function getCurrSelectedTitle() {
      return !this.currSelected.title ? '' : this.currSelected.title;
    },
    onClearSelected: function onClearSelected() {
      this.hiding = true;
      this.checkedKeys = {};
      this.currSelected = {};
      this.nodeSelected = {};
      this.form.resetFields();
      this.selectedKeys = [];
    },
    handleNodeTypeChange: function handleNodeTypeChange(val) {
      this.currSelected.nodeType = val;
    },
    notifyTriggerTypeChange: function notifyTriggerTypeChange(value) {
      this.currSelected.notifyTriggerType = value;
    },
    receiptTriggerTypeChange: function receiptTriggerTypeChange(value) {
      this.currSelected.receiptTriggerType = value;
    },
    submitCurrForm: function submitCurrForm() {
      var _this2 = this;

      this.form.validateFields(function (err, values) {
        if (!err) {
          var formData = Object.assign(_this2.currSelected, values);
          console.log('formData', formData);
          httpAction(_this2.url.add, formData, 'post').then(function (res) {
            if (res.success) {
              _this2.$notification.success({
                message: '保存成功!'
              });

              _this2.loadTree();

              _this2.onClearSelected();
            } else {
              _this2.$message.error(res.message);
            }
          });
        }
      });
    },
    emptyCurrForm: function emptyCurrForm() {
      this.form.resetFields();
    },
    nodeSettingFormSubmit: function nodeSettingFormSubmit() {
      this.form.validateFields(function (err, values) {
        if (!err) {
          console.log('Received values of form: ', values);
        }
      });
    },
    openSelect: function openSelect() {
      this.$refs.sysDirectiveModal.show();
    },
    handleAdd: function handleAdd(num) {
      this.model = {};
      this.currSelected = {};
      this.disableSubmit = false;

      if (num == 1) {
        this.seen = true;
        this.model.parentId = null;
        this.formTitle = '添加一级区域';
        this.emptyCurrForm();
        this.onClearSelected();
      } else {
        var key = this.nodeSelected.key;

        if (!key) {
          this.$message.warning('请先选中一条记录!');
          return false;
        }

        this.seen = false;
        this.model.parentId = key;
        this.currSelected.parentId = key;
        this.formTitle = '添加子区域';
        this.emptyCurrForm();
      }
    },
    handleDelete: function handleDelete() {
      var that = this;
      deleteAction(that.url.deleteBatch, {
        ids: that.rightClickSelectedKey
      }).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });
          that.loadTree();
          that.onClearSelected();
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    },
    selectDirectiveOk: function selectDirectiveOk(record) {
      console.log('选中指令数据', record);
      this.nodeSettingForm.setFieldsValue({
        directiveCode: record.directiveCode
      });
      this.currSelected.sysCode = record.sysCode;
    },
    getFlowGraphData: function getFlowGraphData(node) {
      this.graphDatasource.nodes.push({
        id: node.id,
        text: node.flowNodeName
      });

      if (node.children.length > 0) {
        for (var a = 0; a < node.children.length; a++) {
          var temp = node.children[a];
          this.graphDatasource.edges.push({
            source: node.id,
            target: temp.id
          });
          this.getFlowGraphData(temp);
        }
      }
    }
  }
};